module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My father, Rory MacDonald, has been the inspiration for the Ardnish trilogy, but I also owe thanks to my ancestors, Col. Willie MacDonald and his son Andrew, who fought in the Boer War, and in the First and Second World Wars, and sent a treasure trove of letters home. Their regiment, the Lovat Scots, was formed by Lord Lovat as a ‘sharpshooter’ and reconnaissance unit in 1900, and was made up of deerstalkers, gamekeepers and ghillies from across the Highlands and Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks once more to Erica Munro, as well as to Alison Rae and Andrew Simmons at Birlinn for their sterling editorial work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My research in South Africa was greatly helped by Anthony Hocking, Arnold van Dyk, Pam McFadden from the Talana Museum, Dennis McDonald, Simon and Cheryl Blackburn, Piet Swart, Johan Loock, Thabo Kruger and Redge Henning. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("A.M.")]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/fviii-01.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f00ix-01.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689ac75b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm-03.vue
// module id = 69
// module chunks = 0